import BigNumber from 'bignumber.js';
import type { Address, PublicClient } from 'viem';

import { vBep20Abi } from 'libs/contracts';

export interface GetVTokenCashInput {
  publicClient: PublicClient;
  vTokenAddress: Address;
}

export type GetVTokenCashOutput = {
  cashMantissa: BigNumber;
};

export const getVTokenCash = async ({
  publicClient,
  vTokenAddress,
}: GetVTokenCashInput): Promise<GetVTokenCashOutput> => {
  const res = await publicClient.readContract({
    address: vTokenAddress,
    abi: vBep20Abi,
    functionName: 'getCash',
  });

  return {
    cashMantissa: new BigNumber(res.toString()),
  };
};
